import React, { useState, useEffect } from "react";
import gsap from "gsap";
import "./ValentineApp.css";
import img1 from "./img/img1.jpg";
import img3 from "./img/img3.jpg";
import img2 from "./img/img2.jpg";
import img4 from "./img/img4.jpg";
import img5 from "./img/img5.jpg";
import img6 from "./img/img6.jpg";
import img7 from "./img/img7.jpg";

const images = [img1, img2, img3, img4, img5, img6, img7];

const letterMessages = [
  "My love, if you are with me, I can walk with you through every dark night, turning each step into a path full of light. Your presence is my strength, your love my guide. No matter how tough the journey, together, we’ll shine through. Always by your side, forever in your heart. ❤️",
  "You matter more to me than words can express. You're not just special—you’re different from everyone else in the best way. Your kindness, your love, and the way you make me feel are truly one of a kind. I’m grateful every day to have you by my side. You mean the world to me. ❤️",
  "Every time I look at you, I still get goosebumps. Your smile, your eyes, the way you are—it all feels magical. You make my heart race like the first time we met. No matter how much time passes, you’ll always be the one who gives me butterflies. You’re my forever. ❤️",
  "When you look at me and smile, I feel my body and soul fill with pure happiness. Your smile is my greatest joy, my heart’s favorite melody. In your eyes, I see love, warmth, and a world where I always belong. You are my happiness, my peace, my everything. ❤️",
  "Every moment with you is pure joy. Your time in my life is filled with laughter, love, and unforgettable memories. We have so much fun together, and no matter what, we always find happiness in each other. With you, life feels brighter, and every day is an adventure. I’m so grateful for you! ❤️",
  "Your smile is like sunshine on a rainy day, warming my heart and brightening my world. It’s the sweetest melody, the purest joy, and the most beautiful thing I’ve ever seen. Every time you smile, my worries fade, and all I see is happiness and love. You are my greatest happiness. ❤️",
  "You are my sunflower, always turning towards the light and bringing warmth into my life. No matter how tough the day is, your presence makes everything brighter. Your love, your smile, and your kindness fill my heart with happiness. With you, every day feels beautiful and full of sunshine. ❤️",
];
// Letter Popup Component
const LetterPopup = ({ message, onClose }) => {
  return (
    <div className="letter-overlay">
      <div className="letter-content">
        <button className="letter-close" onClick={onClose}>
          ×
        </button>
        <h2>To my Sunflower,</h2>
        <p>{message}</p>
      </div>
    </div>
  );
};

// Image Popup Component
const ImagePopup = ({ onClose }) => {
  // selectedIndex tracks which image was clicked (null means none selected)
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    // Animate the images inside the popup on mount
    gsap.fromTo(
      ".popup-burst-image",
      {
        y: 50,
        opacity: 0,
        rotation: () => Math.random() * 40 - 20,
      },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.out",
      }
    );
  }, []);

  return (
    <>
      <div className="popup-overlay">
        <div className="popup-content">
          <button className="popup-close" onClick={onClose}>
            ×
          </button>
          <h2>I LOVE YOU TOOOO❤️❤️❤️❤️❤️</h2>
          <div className="popup-images">
            {images.map((src, index) => (
              <img
                key={index}
                src={src}
                className="popup-burst-image"
                alt="burst"
                onClick={() => setSelectedIndex(index)}
              />
            ))}
          </div>
        </div>
      </div>
      {selectedIndex !== null && (
        <LetterPopup
          message={letterMessages[selectedIndex]}
          onClose={() => setSelectedIndex(null)}
        />
      )}
    </>
  );
};

export default ImagePopup;
